<template>
	 <v-container>
		 <v-dialog title="学员加入班级" v-model="hideShow" width="500" persistent>
			<v-card>
				<v-card-title>
					<span>给学员分班</span>
					<v-spacer></v-spacer>
					<v-icon @click="cancel">mdi-close-circle</v-icon>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text class="mt-5">
					<v-row dense>
						
						<v-col cols="12">
							<v-select v-model="add.courseModel" :items="selectCourseList" label="课程" item-text="courseName"
								item-value="id" return-object outlined dense @change="courseChanged"></v-select>
						</v-col>
						<v-col cols="12">
							<v-autocomplete v-model="add.classModel" :items="selectClassList" label="班级" item-text="className"
								item-value="id" return-object outlined dense no-data-text="该课程下无开设的班级"></v-autocomplete>
						</v-col>
						<v-col cols="12">
							<v-menu ref="menu1" v-model="menu1" :close-on-content-click="false"
								transition="scale-transition" offset-y min-width="auto">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field v-model="add.joinDate" label="进班日期" readonly v-bind="attrs" v-on="on"
										dense clearable outlined></v-text-field>
								</template>
								<v-date-picker v-model="add.joinDate" @input="menu1=false" no-title scrollable locale="zh-cn">
									
								</v-date-picker>
							</v-menu>
						</v-col>
						<v-col cols="12" v-if="add.courseModel&&add.courseModel.consumeType=='2'">
							<v-text-field v-model="add.consumePrice" label="每课时扣费金额" dense outlined></v-text-field>
						</v-col>
						
					</v-row>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="cancel">取消</v-btn>
					<v-btn @click="submit" :loading="add.submitting" color="success">确定</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	 </v-container>
</template>

<script>
	import utils from "../config/utils"
	export default {
		name:"create-student",
		props: {
			//显示/隐藏。
			show: {
				type: Boolean,
				default: false
			},
			student:{
				type:Object,
				default:null
			}
			
		},
		watch:{
			show(newVal,oldVal){
				console.log("newVal",newVal);
				this.hideShow = newVal;
				if(this.hideShow){
					
					this.clearAdd();
					
					
					this.getCourseListForSelect();
				}
			}
		},
		data(){
			return {
				menu1:false,
				add: {
					submitting:false,
					courseModel:null,
					classModel:null,
					consumePrice:"",
					joinDate:"",
				},
				selectCourseList:[],
				selectClassList:[],
				hideShow:this.show
			}
		},
		mounted() {
			console.log("student-join-class mounted");
		},
		methods:{
			clearAdd(){
				this.selectCourseList = [];
				this.selectClassList = [];
				this.add.courseModel = null;
				this.add.classModel=null;
				this.add.consumePrice = "";
				this.add.joinDate = utils.getNowDate();
			},
			submit(){
				console.log("提交");
				
				if (!this.add.courseModel) {
					this.$noty.error('请选择课程');
					return
				}
				if (!this.add.classModel) {
					this.$noty.error('请选择要加入的班级');
					return
				}
				
				if (this.add.courseModel.consumeType==='2'){
					if(!this.add.consumePrice){
						this.$noty.error('课时单价不能为空');
						return
					}
				}
				
				this.add.submitting = true;	
				// api
				const that = this;
				let url = `/edu/class/student/create`;
				let postData = {
					shopId:this.student.shopId,
					classId:this.add.classModel.id,
					studentId: this.student.id,
					consumePrice:this.add.consumePrice,
					joinDate:this.add.joinDate,
				};
				
				//console.log("joinData:",postData);
				
				this.axios.post(url, postData).catch(() => {
					that.add.submitting = false;
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("添加成功");
							that.add.submitting = false;
							this.$emit("success","");
							return;
						} else {
							that.add.submitting = false;
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.add.submitting = false;
						that.$noty.error('网络请求失败');
					}
				
				});
				
			},
			cancel(){
				this.$emit("cancel","");
			},
			courseChanged(e){
				const courseId = e.id;
				
				this.add.consumePrice = e.consumePrice;
				
				//获取班级
				this.getClassListForSelect(courseId);
				
			},
			getCourseListForSelect() {
				// 获取课程
				const shopId = this.student.shopId;
				
				if (!shopId) {
					return
				}
			
				const that = this;
				let url = `/edu/shop/course/list/` + shopId;
			
				this.axios.get(url).then(response => {
			
					if (response.data["code"] === 200) {
						let cList = response.data["data"] ? response.data["data"] : [];
						that.selectCourseList = cList.filter(item=>item.status == "1");
						return
					}
			
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			getClassListForSelect(courseId) {
			
				if (!courseId) {
					return
				}
			
				const that = this;
				let url = `/edu/course/all/class/list/` + courseId;
			
				this.axios.get(url).then(response => {
			
					if (response.data["code"] === 200) {
						that.selectClassList = response.data["data"] ? response.data["data"] : [];
						return
					}
			
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
		}
	}
	
</script>

<style>
</style>
